import {BASE_URL} from "../mock/URLs";

export default (image: string): string => {
  return BASE_URL + image;
};
